import { Key01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const KeyRound = /* @__PURE__ */ createIcon(Key01Icon, 'KeyRound');
